if (!customElements.get("m-icon-boxv")) {
  class MIconbox extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".swiper-container");
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider) this.initSlider();
    }

    initSlider() {
      const __this = this;
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const paginationContainer = this.querySelector(".swiper-pagination");

      // sound icon container
      const soundControl = this.querySelector('.ugc-sound-toggle-btn');

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1.4,
        centeredSlides: true, // Required for the focus effect
        loop: true,
        speed: 800,
        spaceBetween: 10,
        // --- CHANGE: Enforce Navigation/Pagination via JS config ---
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        // --------------------------------------------------------
        breakpoints: {
          768: { slidesPerView: 5 }, // Desktop layout
        },
        on: {
          init: function () {
            // Initial Play Logic for the middle video
            setTimeout(() => {
              const activeSlide = this.slides[this.activeIndex];
              const video = activeSlide.querySelector('.video-element');
              if (video) video.play();

              // Setup sound control click
              if(soundControl){
                soundControl.addEventListener('click', function(){
                    this.classList.toggle('muted');
                    // Find the current active video again, as it may have changed
                    const currentActiveSlide = swiperInstance.slides[swiperInstance.activeIndex];
                    const currentActiveVideo = currentActiveSlide.querySelector('.video-element');
                    
                    if(currentActiveVideo){
                        currentActiveVideo.muted = this.classList.contains('muted');
                    }
                });
              }

            }, 200);
          },
          slideChangeTransitionStart: function() {
            // Stop ALL videos immediately when a slide starts moving
            this.slides.forEach(slide => {
              const video = slide.querySelector('.video-element');
              if (video) {
                  video.pause();
                  video.muted = true; // Force-mute sound on old slides
              }
            });
          },
          slideChangeTransitionEnd: function () {
            // Play and Sync Sound Icon with the NEW active slide
            const activeSlide = this.slides[this.activeIndex];
            const video = activeSlide.querySelector('.video-element');
            
            if (video) {
              // Read the state of the sound button and apply to the video
              if(soundControl){
                  video.muted = soundControl.classList.contains('muted');
              } else {
                  video.muted = true; // Fallback if no button
              }
              video.play().catch(e => console.log('Autoplay blocked.', e));
            }
          }
        },
      });

      // Handle click on non-active slides to focus them
      this.slideContainer.addEventListener("click", (e) => {
        const slide = e.target.closest(".swiper-slide");
        if (slide && !slide.classList.contains("swiper-slide-active")) {
          e.preventDefault();
          // use realIndex to avoid duplication issues in loop mode
          const realIndex = slide.getAttribute('data-swiper-slide-index');
          if (realIndex !== null) {
            this.slider.slideToLoop(parseInt(realIndex));
          }
        }
      });
    }
  }

  customElements.define("m-icon-boxv", MIconbox);
}

document.addEventListener('DOMContentLoaded', function() {
  const soundButtons = document.querySelectorAll('.ugc-individual-sound-btn');

  soundButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Find the video in the same container as this button
      const video = this.closest('.m-video__wrapper').querySelector('video');

      if (video) {
        if (video.muted) {
          video.muted = false;
          this.classList.remove('muted');
        } else {
          video.muted = true;
          this.classList.add('muted');
        }
      }
    });
  });
});